import type { NodePropertyValue } from '../../../types/properties';

/**
 * Default configuration for Respond to Trigger node
 */
const defaults: Record<string, NodePropertyValue> = {
  message: '',
  commitToMemory: true,
  responseType: 'text',
  metadata: {}
};

export default defaults;
